import { useCallback } from 'react';
import { useInfiniteQuery } from '@tanstack/react-query';
import { walletApi } from '../api/wallet';
import { useWalletStore } from '../store/walletStore';

export function useWallet() {
  const balance = useWalletStore((s) => s.balance);
  const setBalance = useWalletStore((s) => s.setBalance);

  const refreshBalance = useCallback(async () => {
    const { balance } = await walletApi.getBalance();
    setBalance(balance);
    return balance;
  }, [setBalance]);

  return { balance, setBalance, refreshBalance };
}

export function useTransactions() {
  return useInfiniteQuery({
    queryKey: ['transactions'],
    queryFn: ({ pageParam }: { pageParam: number | undefined }) =>
      walletApi.getTransactions(pageParam),
    initialPageParam: undefined as number | undefined,
    getNextPageParam: (last) => last.nextCursor ?? undefined,
  });
}
